import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "footer" }
const _hoisted_2 = { class: "footer-btn" }
const _hoisted_3 = {
  key: 0,
  class: "tooltiptext"
}
const _hoisted_4 = {
  class: "link-helpdesk",
  href: "https://apoteketab.sharepoint.com/sites/Helpdesk/SitePages/Kontaktaoss.aspx",
  target: "_blank"
}
const _hoisted_5 = {
  key: 0,
  class: "tooltiptext"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass({
          container: true,
          tootip:
            !_ctx.user?.role.permissions.pharmacy.update &&
            _ctx.$route.name === 'EditPharmacy'
        })
      }, [
        _createVNode(_component_Button, {
          variant: _ctx.getVariant(),
          title: _ctx.$t('save'),
          disabled: _ctx.disabledButton(),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('submitForm')))
        }, null, 8, ["variant", "title", "disabled"]),
        (
            !_ctx.user?.role.permissions.pharmacy.update &&
            _ctx.$route.name === 'EditPharmacy'
          )
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.$t('enoughPermissions')), 1))
          : _createCommentVNode("", true)
      ], 2),
      _createElementVNode("a", _hoisted_4, [
        (_ctx.$route.name === 'EditPharmacy')
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 0,
              variant: "wideBordered",
              title: _ctx.$t('referToHelpdesk')
            }, null, 8, ["title"]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", {
        class: _normalizeClass({
          container: true,
          tootip:
            !_ctx.user?.role.permissions.pharmacy.update &&
            _ctx.$route.name === 'EditPharmacy'
        })
      }, [
        _createVNode(_component_Button, {
          variant: _ctx.getVariantButtonCleanFields(),
          title: _ctx.$t('cleanFields'),
          disabled: _ctx.disabledButton(),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('cleanForm')))
        }, null, 8, ["variant", "title", "disabled"]),
        (
            !_ctx.user?.role.permissions.pharmacy.update &&
            _ctx.$route.name === 'EditPharmacy'
          )
          ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.$t('enoughPermissions')), 1))
          : _createCommentVNode("", true)
      ], 2)
    ])
  ]))
}